export { default } from './Renegociacao25Entenda';
